import { normalize } from 'normalizr';

import api from '../../api';
import { schema } from '../../schema';
import { addEntities, removeEntity } from '../../actions';
import Logger from '../../../lib/Logger';
import Format from '../../../lib/Format';

// ACTION TYPES

export const COGNITO_FORM_ANSWER_LIST_REQUEST =
  'COGNITO_FORM_ANSWER_LIST_REQUEST';
export const COGNITO_FORM_ANSWER_LIST_SUCCESS =
  'COGNITO_FORM_ANSWER_LIST_SUCCESS';
export const COGNITO_FORM_ANSWER_LIST_FAILURE =
  'COGNITO_FORM_ANSWER_LIST_FAILURE';
export const COGNITO_FORM_ANSWER_READ_REQUEST =
  'COGNITO_FORM_ANSWER_READ_REQUEST';
export const COGNITO_FORM_ANSWER_READ_SUCCESS =
  'COGNITO_FORM_ANSWER_READ_SUCCESS';
export const COGNITO_FORM_ANSWER_READ_FAILURE =
  'COGNITO_FORM_ANSWER_READ_FAILURE';
export const COGNITO_FORM_ANSWER_CSV_DOWNLOAD_REQUEST =
  'COGNITO_FORM_ANSWER_CSV_DOWNLOAD_REQUEST';
export const COGNITO_FORM_ANSWER_CSV_DOWNLOAD_SUCCESS =
  'COGNITO_FORM_ANSWER_CSV_DOWNLOAD_SUCCESS';
export const COGNITO_FORM_ANSWER_CSV_DOWNLOAD_FAILURE =
  'COGNITO_FORM_ANSWER_CSV_DOWNLOAD_FAILURE';
export const COGNITO_FORM_ANSWER_DELETE_REQUEST =
  'COGNITO_FORM_ANSWER_DELETE_REQUEST';
export const COGNITO_FORM_ANSWER_DELETE_SUCCESS =
  'COGNITO_FORM_ANSWER_DELETE_SUCCESS';
export const COGNITO_FORM_ANSWER_DELETE_FAILURE =
  'COGNITO_FORM_ANSWER_DELETE_FAILURE';

// ACTION CREATORS

export function cognitoFormAnswerListRequest(page, limit, order, filter) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerListRequest(${page}, ${limit}, ${order}, %j)`,
    filter
  );
  return {
    type: COGNITO_FORM_ANSWER_LIST_REQUEST,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  };
}

export function cognitoFormAnswerListSuccess(data) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerListSuccess(%j)`,
    data
  );
  return {
    type: COGNITO_FORM_ANSWER_LIST_SUCCESS,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function cognitoFormAnswerListFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerListFailure(%j)`,
    error
  );
  return {
    type: COGNITO_FORM_ANSWER_LIST_FAILURE,
    error: error,
  };
}

export function cognitoFormAnswerReadRequest(id) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerReadRequest(${id})`
  );
  return {
    type: COGNITO_FORM_ANSWER_READ_REQUEST,
    id: id,
  };
}

export function cognitoFormAnswerReadSuccess(data) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerReadSuccess(%j)`,
    data
  );
  return {
    type: COGNITO_FORM_ANSWER_READ_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function cognitoFormAnswerReadFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerReadFailure(%j)`,
    error
  );
  return {
    type: COGNITO_FORM_ANSWER_READ_FAILURE,
    error: error,
  };
}

export function cognitoFormAnswerDeleteRequest(id) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerDeleteRequest(${id})`
  );
  return {
    type: COGNITO_FORM_ANSWER_DELETE_REQUEST,
    id: id,
  };
}

export function cognitoFormAnswerDeleteSuccess(id) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerDeleteSuccess(${id})`
  );
  return {
    type: COGNITO_FORM_ANSWER_DELETE_SUCCESS,
    id: id,
  };
}

export function cognitoFormAnswerDeleteFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerDeleteFailure(%j)`,
    error
  );
  return {
    type: COGNITO_FORM_ANSWER_DELETE_FAILURE,
    error: error,
  };
}

export function cognitoFormAnswerCSVDownloadRequest(order, filter) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerCSVDownloadRequest()`
  );
  return {
    type: COGNITO_FORM_ANSWER_CSV_DOWNLOAD_REQUEST,
    order: order,
    filter: filter,
  };
}

export function cognitoFormAnswerCSVDownloadSuccess() {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerCSVDownloadSuccess()`
  );
  return {
    type: COGNITO_FORM_ANSWER_CSV_DOWNLOAD_SUCCESS,
  };
}

export function cognitoFormAnswerCSVDownloadFailure() {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerCSVDownloadFailure()`
  );
  return {
    type: COGNITO_FORM_ANSWER_CSV_DOWNLOAD_FAILURE,
  };
}

// API THUNK ACTION CREATORS

export function loadCognitoFormAnswers(
  page = 1,
  limit = 10,
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] loadCognitoFormAnswers(${page}, ${limit}, ${order}, ###)`
  );

  return async function (dispatch) {
    dispatch(cognitoFormAnswerListRequest(page, limit, order, filter));

    // call API
    const response = await api.getCognitoFormAnswers(
      page,
      limit,
      order,
      filter
    );
    let success = false;

    // get cognito form answers list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API cognito form answers list success. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(
        response.getIn(['data', 'cognito_form_answers']),
        [schema.cognitoFormAnswer]
      );
      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(cognitoFormAnswerListSuccess(data));
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API cognito form answers list success [empty]. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(cognitoFormAnswerListSuccess(data));

      // get cognito form answers list failure
    } else {
      Logger.log(
        'info',
        `Get API cognito form answers list failure. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(cognitoFormAnswerListFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function loadCognitoFormAnswer(id, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] loadCognitoFormAnswer(${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(cognitoFormAnswerReadRequest(id));

    // call API
    const response = await api.getCognitoFormAnswer(id);
    let success = false;

    // get cognito form answer success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API cognitoFormAnswer success. ID: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'cognito_form_answer'])],
        [schema.cognitoFormAnswer]
      );
      const data = {
        id: response.getIn(['data', 'cognito_form_answer', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(cognitoFormAnswerReadSuccess(data));
      success = true;

      // get cognito form answer failure
    } else {
      Logger.log('info', `Get API cognitoFormAnswer failure. ID: ${id}.`);
      dispatch(cognitoFormAnswerReadFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function deleteCognitoFormAnswer(id, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] deleteCognitoFormAnswer(${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(cognitoFormAnswerDeleteRequest(id));

    // call API
    const response = await api.deleteCognitoFormAnswer(id);
    let success = false;

    // delete cognito form answer success
    if (204 === response.get('status')) {
      Logger.log('info', `DELETE API cognito form answer success. ID: ${id}.`);

      dispatch(removeEntity({ entityType: 'cognitoFormAnswers', id: id }));
      dispatch(cognitoFormAnswerDeleteSuccess(id));
      success = true;

      // get cognito form answer failure
    } else {
      Logger.log('info', `DELETE API cognito form answer failure. ID: ${id}.`);
      dispatch(
        cognitoFormAnswerDeleteFailure(response.getIn(['data', 'error']))
      );
    }

    // callback function
    cb(success);
  };
}

export function downloadCognitoFormAnswersCSV(
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] downloadCognitoFormAnswersCSV(${order}, ${filter}, ###)`
  );

  return async function (dispatch) {
    dispatch(cognitoFormAnswerCSVDownloadRequest(order, filter));

    // call API
    const response = await api.getCognitoFormAnswersCSV(order, filter);

    // get cognito form answers CSV success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API cognito form answers CSV success. Order: ${order}`
      );
      const now = new Date();

      // trigger browser download
      const url = window.URL.createObjectURL(new Blob([response.get('data')]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `cv-cognito-form-answers-${Format.date(now, 'YYYY-MM-DDTHHmm')}.csv`
      );
      document.body.appendChild(link);
      link.click();

      dispatch(cognitoFormAnswerCSVDownloadSuccess());

      // get cognito form answers CSV failure
    } else {
      Logger.log('info', `Get API cognito form answers CSV failure.`);
      dispatch(cognitoFormAnswerCSVDownloadFailure());
    }

    // callback function
    cb();
  };
}

Logger.log('silly', `cognitoFormAnswers.actions loaded.`);
